export default __webpack_public_path__ + "static/media/category2.b3f0b1ab.png";